export enum EdgeType {
  ORIGINAL = 0,
  SHORTENED = 1,
  FROMCUT = 2,
}
